import {useRef} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {useAuth} from '@/context/AuthContext';
import {useUiLanguage} from '@/i18n/useUiLanguage';
import {commerceText} from '@/i18n/commerceCopy';
import {activeCommerceSection, commerceSections, isCommercePath} from '@/commerceNavigation';

export default function CommerceNavigation() {
  useUiLanguage();
  const menu = useRef(null);
  const {user, workspace, hasModule} = useAuth();
  const {pathname, search} = useLocation();
  const sections = commerceSections(workspace?.role || user?.role, workspace?.capabilities?.inventory);
  if (!isCommercePath(pathname) || !hasModule('inventory') || !sections.length) return null;
  const active = activeCommerceSection(pathname, search);
  return <section className="mb-6 min-w-0" data-testid="commerce-navigation">
    <details ref={menu} className="rounded-xl border bg-card">
      <summary className="min-h-12 cursor-pointer p-4 text-sm focus-visible:outline focus-visible:outline-primary">
        <span className="font-semibold">{commerceText('Magazzino & Vendite')}</span>
        <span className="mx-2 text-muted-foreground">/</span>
        <span>{commerceText(sections.find(section=>section.id===active)?.label || 'Magazzini')}</span>
      </summary>
      <nav aria-label={commerceText('Sezioni Magazzino & Vendite')} className="grid gap-1 border-t p-2 sm:grid-cols-2">
        {sections.map(section => <Link key={section.id} to={section.to}
          onClick={()=>{if(menu.current){menu.current.open=false;menu.current.querySelector('summary')?.focus();}}}
          aria-current={active === section.id ? 'page' : undefined}
          className={`flex min-h-11 min-w-0 items-center rounded-lg px-3 py-3 text-sm break-words focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary ${active === section.id ? 'bg-primary/10 font-semibold text-primary' : 'text-foreground hover:bg-accent'}`}>
          {commerceText(section.label)}
        </Link>)}
      </nav>
    </details>
  </section>;
}
